import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fees-pending-report',
  templateUrl: './fees-pending-report.component.html',
  styleUrls: ['./fees-pending-report.component.css']
})
export class FeesPendingReportComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
